import React, { Suspense, lazy } from 'react';
import './components/PreloadAssets';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/sections/Hero';
import { SocialProofBar } from './components/sections/SocialProofBar';
// Below-the-fold sections lazy-loaded to dramatically reduce initial JS/render cost on mobile
const TopReviews = lazy(() => import('./components/sections/TopReviews').then(m => ({
  default: m.TopReviews
})));
const Agitation = lazy(() => import('./components/sections/Agitation').then(m => ({
  default: m.Agitation
})));
const BeforeAfter = lazy(() => import('./components/sections/BeforeAfter').then(m => ({
  default: m.BeforeAfter
})));
const WhoFor = lazy(() => import('./components/sections/WhoFor').then(m => ({
  default: m.WhoFor
})));
const WhyDifferent = lazy(() => import('./components/sections/WhyDifferent').then(m => ({
  default: m.WhyDifferent
})));
const SixBooks = lazy(() => import('./components/sections/SixBooks').then(m => ({
  default: m.SixBooks
})));
const ContentPreview = lazy(() => import('./components/sections/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const Bonuses = lazy(() => import('./components/sections/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Offer = lazy(() => import('./components/sections/Offer').then(m => ({
  default: m.Offer
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(m => ({
  default: m.Guarantee
})));
const Mission = lazy(() => import('./components/sections/Mission').then(m => ({
  default: m.Mission
})));
const SocialFeed = lazy(() => import('./components/sections/SocialFeed').then(m => ({
  default: m.SocialFeed
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(m => ({
  default: m.FAQ
})));
const Numbers = lazy(() => import('./components/sections/Numbers').then(m => ({
  default: m.Numbers
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/sections/Footer').then(m => ({
  default: m.Footer
})));
const SectionFallback = () => <div className="w-full h-64" aria-hidden="true" data-id="element-0" />;
export function App() {
  return <div className="w-full min-h-screen" data-id="element-1">
      <MetaPixel data-id="element-2" />
      <Hero data-id="element-3" />
      <SocialProofBar data-id="element-4" />
      <Suspense fallback={<SectionFallback data-id="element-6" />} data-id="element-5">
        <TopReviews data-id="element-7" />
        <Agitation data-id="element-8" />
        <BeforeAfter data-id="element-9" />
        <WhoFor data-id="element-10" />
        <WhyDifferent data-id="element-11" />
        <SixBooks data-id="element-12" />
        <ContentPreview data-id="element-13" />
        <Bonuses data-id="element-14" />
        <Offer data-id="element-15" />
        <Guarantee data-id="element-16" />
        <Mission data-id="element-17" />
        <SocialFeed data-id="element-18" />
        <FAQ data-id="element-19" />
        <Numbers data-id="element-20" />
        <FinalCTA data-id="element-21" />
        <Footer data-id="element-22" />
      </Suspense>
    </div>;
}